import Waypoint from 'waypoints'

const overlayer = document.querySelector('.overlayer')

    const waypoint = new Waypoint({
        element: document.getElementById('game'),
        handler: function(direction) {
            if( direction === 'down' && overlayer.classList.contains('overlayer--active')) {
                overlayer.classList.remove('overlayer--active')
                this.element.classList.add('game--paused')
            } else if(direction === 'up' && this.element.classList.contains('game--paused')) {
                overlayer.classList.add('overlayer--active')
                this.element.classList.remove('game--paused')
            }
        },
        offset: function () {
            return -this.element.clientHeight
        }
    })
